import { useMutation } from "react-query";
import { IeLynxUser } from "../../common/models/eLynxUser";
import { RestError } from "../../services/rest-service/RestService";
import UserDataService from "../../services/user-data-service/UserDataService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";


type MutationContextType = {
    previousUserProfile: IeLynxUser | undefined;
};

export function useSaveUserProfile(params: BaseUseMutationParameters<IeLynxUser, IeLynxUser>) {
    //const queryClient = useQueryClient();

    return useMutation<IeLynxUser, RestError, IeLynxUser, MutationContextType>(
        (user) => {
            return UserDataService.saveUserProfile(user);
        },
        {
            // onMutate: async (runTicket: IRunTicketModel) => {

            //     await queryClient.cancelQueries(keys.all);

            //     const previousRunTickets = queryClient.getQueryData<IeLynxUser>(
            //         keys.settings(user.)
            //         )
            //     );

            //     queryClient.setQueryData<IRunTicketData>(
            //         keys.list(
            //             customerID,
            //             groupID,
            //             eLynxObject,
            //             offline,
            //             timestamp
            //         ),
            //         (old?: IRunTicketData) => {
            //             return {
            //                 runTickets: [...old?.runTickets ?? [], runTicket],
            //                 tanks: old?.tanks
            //             } as IRunTicketData;
            //         }
            //     );

            //     return {
            //         previousRunTickets
            //     };
            // },
            onError: params.onError,
            onSuccess: params.onSuccess,
            // onSettled: (_data, error, _user, context) => {

            //     //queryClient.invalidateQueries(keys.all);
            //     queryClient.setQueryData()
            // }
        }
    );
}
